import { useQuery } from "@tanstack/react-query";
import { getUnresolvedPastAppointments } from "../api/appointmentApi";

export const usePastConfirmedAppointments = ({ paused = false } = {}) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["appointments", "unresolved"],
    queryFn: getUnresolvedPastAppointments,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
    enabled: !paused,
  });

  return {
    pastConfirmedAppointments: data?.appointments || [],
    isLoading,
    isError,
  };
};
